import styled from 'styled-components';

export const LightboxDocument = styled.iframe.attrs({
    'data-testid': 'lightbox-document-element',
    height: '100%',
    /*
     * This must be sandboxed to prevent scripts or external resources from executing inside the iframe
     * As we can't guarentee that the asset won't contain malicous content, and we can't sanitize an external URL
     */
    sandbox: '',
    width: '100%',
})`
    height: 80vh;
    width: 100%;
    max-width: 80vh;
`;
